const _div = document.createElement("div");

export function stripHtml(html) {
  _div.innerHTML = html;
  return _div.textContent || _div.innerText || "";
}
